export type SliderComponentValue = number | null;
